var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 30,
    viewBox: "0 0 58 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 30,
    rx: 4,
    fill: "#FAFAF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0009 14.9998C28.4065 16.1538 27.6095 17.1915 26.6479 18.0635C26.042 18.6697 25.2698 19.0825 24.4292 19.2498C23.5886 19.4171 22.7172 19.3314 21.9253 19.0034C21.1335 18.6755 20.4566 18.1201 19.9804 17.4074C19.5042 16.6948 19.25 15.8569 19.25 14.9998C19.25 14.1427 19.5042 13.3049 19.9804 12.5922C20.4566 11.8796 21.1335 11.3242 21.9253 10.9962C22.7172 10.6683 23.5886 10.5826 24.4292 10.7499C25.2698 10.9172 26.042 11.33 26.6479 11.9362C27.6095 12.8082 28.4065 13.8459 29.0009 14.9998ZM29.0009 14.9998C29.5954 13.8459 30.3924 12.8082 31.3539 11.9362C31.9599 11.33 32.732 10.9172 33.5726 10.7499C34.4133 10.5826 35.2846 10.6683 36.0765 10.9962C36.8684 11.3242 37.5453 11.8796 38.0215 12.5922C38.4977 13.3049 38.7519 14.1427 38.7519 14.9998C38.7519 15.8569 38.4977 16.6948 38.0215 17.4074C37.5453 18.1201 36.8684 18.6755 36.0765 19.0034C35.2846 19.3314 34.4133 19.4171 33.5726 19.2498C32.732 19.0825 31.9599 18.6697 31.3539 18.0635C30.3924 17.1915 29.5954 16.1538 29.0009 14.9998Z",
    stroke: "#272523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.984551331e34fc3fba3dd8a9a30e6a41.svg";
export { ForwardRef as ReactComponent };